export default (obj, value) => {
  return obj.sort((a, b) => {
    return a[value] - b[value]
  })
}
